/* eslint-disable */

export interface ShowStarterExamDto {
  examId?: number | null
  examName?: string | null
  type?: string | null
}

export interface ShowStarterDto {
  startNo?: number | null
  horseName?: string | null
  horseRegisterId?: string | null
  riderFirstName?: string | null
  riderLastName?: string | null
  riderRegisterId?: string | null
  scoringTypeName?: string | null
  exams?: ShowStarterExamDto[] | null
}

export function instanceOfShowStarterDto(value: object): value is ShowStarterDto {
  return true
}

export function ShowStarterDtoFromJSON(json: any): ShowStarterDto {
  if (json == null) return json
  return {
    startNo:         json['startNo']         ?? undefined,
    horseName:       json['horseName']       ?? undefined,
    horseRegisterId: json['horseRegisterId'] ?? undefined,
    riderFirstName:  json['riderFirstName']  ?? undefined,
    riderLastName:   json['riderLastName']   ?? undefined,
    riderRegisterId: json['riderRegisterId'] ?? undefined,
    scoringTypeName:  json['scoringTypeName']  ?? undefined,
    exams: json['exams']
      ? (json['exams'] as any[]).map(e => ({ examId: e['examId'] ?? undefined, examName: e['examName'] ?? undefined, type: e['type'] ?? undefined }))
      : undefined,
  }
}

export function ShowStarterDtoToJSON(value?: ShowStarterDto | null): any {
  if (value == null) return value
  return { ...value }
}
